import en from "../translations/en";
import es from "../translations/es";

// Mapa de idiomas disponibles
const translations = {
  en,
  es,
};

// Función para obtener la traducción de un texto
export const translateText = (text, lang = "es") => {
  const selectedLang = translations[lang] || translations["es"];
  return selectedLang[text] || text; // Si no encuentra el texto, devuelve el original
};
